import axios from 'axios';
import { minTurnoverValue, minNumberOfMatches } from '../constants';

const apiUrl = `${process.env.REACT_APP_BACKEND}/betfair/1/`;

export function fetchFeed (url, clientId, productId) {
  url = `${apiUrl}${clientId}/${productId}`;
  return (dispatch, getState) => {
    dispatch(fetchFeedRequest());
    axios.get(url)
    .then(function (response) {
      if (response.status === 200) {
        dispatch(changeClientStatus(false));
        if (Object.keys(response.data.matches).length){
          let dataArr = [];
          Object.keys(response.data.matches).forEach((key)=>{
              dataArr.push(response.data.matches[key]);
          });
          dispatch(fetchFeedSuccess(dataArr));
        }

        if (Object.keys(response.data.currency).length) {
          //update rates
          dispatch(updateRates(response.data.currency.rates));
        }

        if (Object.keys(response.data.client).length) {
          //update locale
          dispatch(updateLocale(response.data.client.locale));

          //add textlink if exists
          if (Object.keys(response.data.client).length && response.data.client.textlink && response.data.client.textlink !== '') {
            dispatch(updateTextlink(response.data.client.textlink));
          }

          //updateFeed domain url
          dispatch(updateFeedDomainUrl(response.data.client.feed_domain_url));

          //update odd format if not set in local storage
          if (!localStorage.getItem('betfair_app_prefered_odds_format')) {dispatch(updateOddsFormat(response.data.client.odd_format));}

          //update currency if not set in local storage
          if (!localStorage.getItem('betfair_app_currency') ) {dispatch(updateCurrency(response.data.client.currency));}
        }
      }
    })
    .catch(function (error) {
      if (error.config && error.config.headers && !error.config.headers['access-control-allow-origin']) {
        dispatch(changeClientStatus(true));
      }
      dispatch(fetchFeedError(error));
    })
  }
};


const fetchFeedRequest = () => {
  return {
    type: 'FETCH_FEED_REQUEST',
  }
}

const fetchFeedSuccess = (feedData) => {
  return {
    type: 'FETCH_FEED_SUCCESS',
    feedData: filterFeedData(feedData)
  }
}

const fetchFeedError = (error) => {
  return {
    type: 'FETCH_FEED_ERROR',
    error
  }
}

const changeClientStatus = (clientDisabled) => {
  return {
    type:'CLIENT_STATUS',
    clientDisabled
  }
}

export const sortFeedData = (feedData) => {
  return {
    type: 'SORT_FEED_DATA',
    feedData
  }
}

export const updateSortFilter = (sortFilter) => {
  return {
    type: 'UPDATE_SORT_FILTER',
    sortFilter
  }
}

export const updateGmtOffset = (gmtOffset) => {
  return {
    type:'UPDATE_GMT_OFFSET',
    gmtOffset
  }
}

export const updateOddsFormat = (oddsFormat) => {
  return {
    type: 'UPDATE_ODDS_FORMAT',
    oddsFormat
  }
}

export const updateCurrency = (currency) => {
  return {
    type: 'UPDATE_CURRENCY',
    currency
  }
}

const updateRates = (rates) => {
  return {
    type:'UPDATE_RATES',
    rates
  }
}

const updateLocale = (locale) => {
  return {
    type:'UPDATE_LOCALE',
    locale
  }
}

const updateFeedDomainUrl = (feedDomainUrl) => {
  return {
    type:'UPDATE_FEED_DOMAIN_URL',
    feedDomainUrl
  }
}

const updateTextlink = (textlink) => {
  return {
    type:'UPDATE_TEXTLINK',
    textlink
  }
}

export const toggleSettings = (isSettingsOpen) => {
  return {
    type:'SETTINGS_TOGGLE',
    isSettingsOpen
  }
}

export const filterFeedData = (data) => {
  const limitedData = data.slice().filter( entry => {
    return entry.odds[0] !== undefined && parseFloat(entry.odds[0].book.odd_s) > minTurnoverValue;
  });
  const restOfData = data.filter(x => !limitedData.includes(x));
  data = limitedData.length < minNumberOfMatches
    ? limitedData.concat(restOfData.slice(0, minNumberOfMatches - limitedData.length))
    : limitedData;
  return data;
}



// WEBPACK FOOTER //
// ./src/state/actions.js